import { computed } from 'vue';
import { get } from 'lodash';

import { namesToFullName, sanitizeInput } from '@nova/core';
import useYardTaskEvent from './useYardTaskEvent';

import type { YardTaskTimelineEvent } from '@satellite/composables/useYardTaskTimeline';
import type { UseYardTaskEventOptions } from './useYardTaskEvent';

/**
 * Composable for comment event that extends base event composable
 * @param {YardTaskTimelineEvent} event
 * @param {UseYardTaskEventOptions} options
 * @returns {Object} Base event data plus comment-specific data
 */
export default function useYardTaskCommentEvent(
  event: YardTaskTimelineEvent,
  options: UseYardTaskEventOptions
) {
  const baseEventData = useYardTaskEvent(event, options);

  /**
   * For Comment events, user is at data.user (not data.data.user),
   * so we override `user` to handle Comment event structure
   */
  const user = computed(() => {
    const user = get(event, 'data.user') || baseEventData.user.value;

    return user || null;
  });

  const htmlContent = computed(() => {
    return sanitizeInput(get(event, 'data.htmlContent') || '');
  });

  return {
    ...baseEventData,
    user,
    htmlContent
  };
}
